export const WORDS = [
  'snarl',
  'limer',
  'check',
  'grape',
  'fearo',
  'vivid',
  'tenth',
  'berry',
  'minty',
  'pixie',
  'ooooo',
  'demon',
  'crush',
  'three',
  'rojos',
  'minos',
  'onion',
  'bolto',
  'snake',
  'rozzy',
  'event',
  'momos',
  'widow',
  'dwarf',
  'mango',
  'sixth',
  'glass',
  'baloo',
  'tuber',
  'amber',
  'vespa',
  'cocoa',
  'rango',
  'mogul',
  'smoke',
  'swans',
  'gorby',
  'swarm',
  'scary',
  'oozer',
  'ember',
  'rasta',
  'atlas',
  'specs',
  'joust',
  'fairy',
  'fresh',
  'heart',
  'relay',
  'gonzo',
  'third',
  'meter',
  'first',
  'ducks',
  'shore',
  'fudge',
  'blood',
  'geese',
  'teams',
  'moons',
  'stars',
  'chaos',
  'rolls',
  'patch',
  'wespy',
  'sauce',
  'razzy',
  'racer',
  'rezzy',
  'guild',
  'timmy',
  'pollo',
  'graze',
  'medal',
  'skate',
  'cobra',
  'frost',
  'split',
  'super',
  'polar',
  'frank',
  'rolla',
  'lemon',
  'terra',
  'round',
  'latte',
  'orbit',
  'slime',
  'taffy',
  'savvy',
  'misty',
  'mikey',
  'roldo',
  'quali',
  'wispy',
  'quick',
  'glace',
  'royal',
  'waspy',
  'cosmo',
  'boltu',
  'comet',
  'trunk',
  'seven',
  'mania',
  'swirl',
  'anger',
  'tiger',
  'bugsy',
  'conda',
  'track',
  'wuspy',
  'nyoom',
  'rally',
  'ramen',
  'gummy',
  'flare',
  'foggy',
  'jimmy',
  'slide',
  'rizzy',
  'orcas',
  'blast',
  'blade',
  'shiny',
  'ghost',
  'queen',
  'black',
  'rubow',
  'ruzzy',
  'medic',
  'rolly',
  'speed',
  'rollo',
  'swift',
  'balls',
  'sweet',
  'rafts',
  'yodel',
  'dazey',
  'crazy',
  'wospy',
  'murky',
  'cross',
  'strix',
  'rayze',
  'roman',
  'storm',
  'ringo',
  'hazer',
  'moody',
  'meepo',
  'sugar',
  'curse',
  'bingo',
  'billy',
  'micky',
  'sting',
  'jacks',
  'rapid',
  'fired',
  'snail',
  'yoggy',
  'water',
  'block',
  'indie',
  'clash',
  'remus',
  'wisps',
  'gnome',
  'earth',
  'winky',
  'fifth',
  'white',
  'goose',
  'wyspy',
  'diego',
  'glide',
  'roses',
  'broth',
  'jelle',
  'green',
  'ducky',
  'glory',
  'honey',
  'hosts',
  'ounce',
  'candy',
  'coach',
  'shade',
  'bolta',
  'perry',
  'flash',
  'prima',
  'bolty',
  'blaze',
  'ocean',
  'ninth',
  'moths',
  'pygmy',
  'power',
  'shawn',
  'sheep',
  'barry',
  'balto',
  'start',
  'apple',
  'shock',
  'pearl',
  'pinky',
  'willo',
  'sheet',
  'mocha',
  'grass',
  'akela',
  'tawny',
  'cinco',
  'flame',
  'spade',
  'races',
  'siren',
  'sport',
  'clubs',
  'woods',
  'screw',
  'dance',
  'gleam',
  'azure',
  'snowy',
]
